import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },
    // 3 - Patient Management
    {
        id: 3,
        label: 'Patient Management',
        icon: 'ri-user-heart-line',
        link: '/patientManagement/list'
    },

    // 12 - Care Protocol
    {
        id: 12,
        label: 'Care Protocol',
        icon: 'ri-heart-line',
        link: '/care-protocol/list',
        roles: ['SUPER_ADMIN']
    },

    // 6 - Assign Protocol to Patient
    {
        id: 6,
        label: 'Assign Protocol',
        icon: 'ri-user-shared-line',
        link: '/patient-protocol/assign',
        roles: ['SUPER_ADMIN']
        // subItems: [
        //     { id: 7, label: 'Assign Protocol',  parentId: 6 },
        //     { id: 8, label: 'Assigned List', link: '/patient-protocol/assigned-list', parentId: 6 },
        // ],
    },

    // 9 - Patient Protocols
    // {
    //     id: 9,
    //     label: 'Patient Protocols',
    //     icon: 'ri-file-list-3-line',
    //     subItems: [
    //         { id: 10, label: 'Protocols List', link: '/patient-protocols/list', parentId: 9 },
    //         { id: 11, label: 'Add Protocol', link: '/patient-protocols/add', parentId: 9 },
    //     ],
    // },



    // 15 - Our Products
    {
        id: 15,
        label: 'Our Products',
        icon: 'ri-archive-line',
        link: '/product/productlist',
    },

    // 18 - Product Categories
    {
        id: 18,
        label: 'Product Categories',
        icon: 'ri-price-tag-3-line',
        link: '/product-categories/list',
    },

    // 21 - Order & Replenishment
    {
        id: 21,
        label: 'Order & Replenishment',
        icon: 'ri-truck-line',
        link: '/order/list',
        roles: ['SUPER_ADMIN', 'PATIENT']
        // subItems: [
        //     { id: 22, label: 'Orders List',  parentId: 21 },
        //     { id: 23, label: 'Replenishment', link: '/order/replenishment', parentId: 21 },
        // ],
    },


    // 24 - Billings Management
    {
        id: 24,
        label: 'Billings & Profiles',
        icon: 'ri-bill-line',
        roles: ['SUPER_ADMIN', 'PATIENT'],
        subItems: [
            { id: 26, label: 'Profiles', link: '/billing-profile/list', parentId: 24 },
            { id: 25, label: 'Invoices', link: '/billing/invoicesList', parentId: 24 },
            { id: 27, label: 'Prepaid Billings', link: '/billing/prepaid-billings', parentId: 24 },
            { id: 28, label: 'Refunded Invoices', link: '/billing/Refund-list', parentId: 24 },
        ],
    },
    // {
    //     id: 24,
    //     label: 'Billings Management',
    //     icon: 'ri-bill-line',
    //     subItems: [
    //         { id: 26, label: 'Invoices', link: '/billing/invoicesList', parentId: 24 },
    //         { id: 25, label: 'Billing Shell', link: '/billing/billing-shell', parentId: 24 },
    //         // { id: 26, label: 'Payments', link: '/billing/payments', parentId: 24 },
    //     ],
    // },

    // 27 - Subscription Management
    // {
    //     id: 27,
    //     label: 'Manage Subscriptions',
    //     icon: 'ri-repeat-2-line',
    //     subItems: [
    //         { id: 28, label: 'Subscriptions List', link: '/subscription/list', parentId: 27 },
    //         { id: 29, label: 'Plans', link: '/subscription/plans', parentId: 27 },
    //     ],
    // },

    // 35 - Chat Module 
    {
        id: 35,
        label: 'Chat',
        icon: 'ri-chat-3-line',
        roles: ['SUPER_ADMIN', 'PATIENT'],
        link: '/chat'
    },

    // 30 - Admin
    {
        id: 30,
        label: 'Admin',
        icon: 'ri-admin-line',
        roles: ['SUPER_ADMIN'],
        subItems: [
            { id: 31, label: 'Users', link: '/admin/userlist', parentId: 30 },
            // { id: 32, label: 'Roles & Permissions', link: '/admin/roles', parentId: 30 },
        ],
    },

    // 34 - Replenish Dashbaord
    // {
    //     id: 34,
    //     label: 'Replenish Dashboard',
    //     icon: 'ri-dashboard-line',
    //     link: '/replenish/Replenish-Dashboard'
    // },


    // 33 - Trash Bin
    {
        id: 33,
        label: 'Trash Bin',
        icon: 'ri-delete-bin-line',
        link: '/trash/trash-bin',
        roles: ['SUPER_ADMIN']
    },

    // Calander
    {
        id: 34,
        label: 'MENUITEMS.CALENDAR.TEXT',
        icon: 'ri-calendar-2-line',
        link: '/calendar'
    },



    // Patients Routes and Access:::::::
    // 21 - Order & Replenishment

    {
        id: 35,
        label: 'My Orders',
        icon: 'ri-truck-line',
        link: '/my-orders',
        roles: ['PATIENT']
    },
    {
        id: 36,
        label: 'My Protocols',
        icon: 'ri-user-shared-line',
        link: '/my-protocols',
        roles: ['PATIENT']
    },
    {
        id: 37,
        label: 'Billing & Profiles',
        icon: 'ri-bill-line',
        roles: ['PATIENT'],
        subItems: [
            { id: 37.1, label: 'Billing Profile', link: '/My-BillingProfile', parentId: 37 },
            { id: 37.2, label: 'Invoices', link: '/My-Invoices', parentId: 37 },
        ],
    },
    {
        id: 37,
        label: 'Inventory Management',
        icon: 'ri-bill-line',
        roles: ['PATIENT'],
        subItems: [
            { id: 37.1, label: 'Billing Profile', link: '/My-BillingProfile', parentId: 37 },
            { id: 37.2, label: 'Invoices', link: '/My-Invoices', parentId: 37 },
        ],
    },


];